import type { ExtensionOptions } from '../../../types';

/**
 * This function is used to determine if the options supplied to an iframe
 * when it is created is enough to prime the context cache.
 * This saves a content resolver round trip.
 */
export const isValidExtensionOptionsForCache = (options: ExtensionOptions) => {
	const jwtIsFresh =
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		!options.contextJwt || !window.connectHost.isJwtExpired(options.contextJwt, true);
	let validExtensionOptionsForCache = jwtIsFresh && !!options.structuredContext;

	if (validExtensionOptionsForCache) {
		// We also need to check the validity of the structured context by checking that structured context exists when we have product context.
		// The default value of structured context is an empty object. Structured context is not one of the chosen properties passed through
		// when a dialog is created but product context is passed through. In addition, there are times when there is no context and a blank
		// product context object is correct.
		const hasProductContext =
			options.productContext && Object.getOwnPropertyNames(options.productContext).length > 0;
		const hasStructuredContext = Object.getOwnPropertyNames(options.structuredContext).length > 0;
		const structuredContextIsValid = !hasProductContext || hasStructuredContext;
		if (!structuredContextIsValid) {
			validExtensionOptionsForCache = false;
		}
	}

	return validExtensionOptionsForCache;
};
